/* LOSMIOS Mundial FX — pointer spotlight + scroll reveal + bar fill. No deps.
   Inspirado en 21st.dev (Spotlight Card). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function spotlight() {
    if (reduce) return;
    var cards = document.querySelectorAll('.lm-mw .player-card, .lm-mw .drop-item, .lm-mw .proof-card, .lm-mw .flag-chip, .lm-mw .cd-box');
    cards.forEach(function (c) {
      if (c.dataset.fxSpot) return; c.dataset.fxSpot = '1';
      c.classList.add('lm-fx-spot');
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        c.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
        c.style.setProperty('--op', '1');
      });
      c.addEventListener('pointerleave', function () { c.style.setProperty('--op', '0'); });
    });
  }

  function reveal() {
    var items = document.querySelectorAll('.lm-mw .player-card, .lm-mw .proof-card, .lm-mw .vs-col, .lm-mw .drop-item, .lm-mw .flag-chip');
    if (reduce) { items.forEach(function (i) { i.classList.add('lm-fx-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lm-fx-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    items.forEach(function (el, i) {
      el.classList.add('lm-fx-anim');
      el.style.transitionDelay = (i % 6) * 60 + 'ms';
      io.observe(el);
    });
  }

  function bars() {
    var blocks = document.querySelectorAll('.lm-mw .drops .wrap, .lm-mw .drop-grid');
    if (reduce) { blocks.forEach(function (b) { b.classList.add('lm-fx-seen'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lm-fx-seen'); io.unobserve(e.target); } });
    }, { threshold: 0.25 });
    blocks.forEach(function (b) { io.observe(b); });
  }

  function boot() { spotlight(); reveal(); bars(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
